import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
var Card = function Card(_ref) {
  var borderColor = _ref.borderColor,
    children = _ref.children,
    className = _ref.className,
    dataTestId = _ref['data-testid'];
  return /*#__PURE__*/React.createElement("div", {
    className: cx('border border-solid rounded overflow-hidden', borderColor, className),
    "data-testid": dataTestId
  }, children);
};
Card.propTypes = {
  borderColor: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  'data-testid': PropTypes.string
};
Card.defaultProps = {
  borderColor: 'border-dark-border-blue',
  className: '',
  'data-testid': undefined
};
export default Card;
//# sourceMappingURL=Card.js.map